import { render, staticRenderFns } from "./product-review-mini.vue?vue&type=template&id=2d0e86be&scoped=true&"
import script from "./product-review-mini.vue?vue&type=script&lang=js&"
export * from "./product-review-mini.vue?vue&type=script&lang=js&"
import style0 from "./product-review-mini.vue?vue&type=style&index=0&id=2d0e86be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0e86be",
  null
  
)

export default component.exports